import styled from 'styled-components';

export const VideoPlayerPlaceholder = styled.div`
	color: white;
`;

export const VideoThumbnail = styled.div`
	width: 100%;
	height: 100%;
	position: relative;
	cursor: pointer;
	overflow: hidden;
	border-radius: 16px;
`;

export const PlayButton = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 10;
	pointer-events: none;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: opacity 0.3s ease;
`;
